import React from "react";
import ServiceCard from "../components/ServiceCard";
import Hero from "../components/Hero";

export default function Home({ t, langData }) {
  const services = langData.home2.services; // ← Array من JSON

  return (
    <>
      <Hero t={t} subtitle={langData.home2.servicesSubtitle} />

      <section className="services-section" aria-labelledby="home-services-title">
        <div className="container">
          <div className="services-heading">
            <span className="services-heading__eyebrow">Italiano988 / 01</span>
            <h2 id="home-services-title">{langData.home2.servicesTitle}</h2>
            <p>{langData.home2.servicesSubtitle}</p>
          </div>
          <div className="row g-4">
            {services.map((s, idx) => (
              <div className="col-md-6 col-xl-3" key={s.title}>
                <ServiceCard {...s} index={idx} />
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
